module.exports = __webpack_public_path__ + "media/images/camo_small-55582085.gif";